module.exports = __webpack_public_path__ + "images/img-32.ab4b64e9.jpg";